import styled from 'styled-components';

const TitleContainer = styled.div`
  justify-content: space-between;
  display: flex;
`;

const StatusBoxContainer = styled.div`
  align-items: center;
  display: flex;
`;

const StatusIcon = styled.img`
  margin: 0 5px 0 40px;
`;

export { TitleContainer, StatusBoxContainer, StatusIcon };
